import { HexColorPicker } from 'react-colorful'
import { ComponentProps } from 'react'
import Styles from './ColorPicker.module.scss'
import { Input } from 'almanac-ui/TextInputField/Input'

interface Props extends Partial<ComponentProps<typeof HexColorPicker>> {
  withHexInput?: boolean
  margin?: string
}
export const ColorPicker = ({ withHexInput = true, margin = undefined, ...props }: Props) => {
  const handleChange = (value: string) => {
    if (props.onChange) {
      if (!value.startsWith('#')) {
        value = `#${value}`
      }
      props.onChange(value)
    }
  }

  return (
    <div className={Styles.colorPicker} style={{ margin }}>
      <HexColorPicker {...props} />
      {withHexInput && (
        <div className={Styles.hexInput}>
          <div className={Styles.label}>Hex Code</div>
          <Input
            aria-label="Hex Value"
            className={Styles.input}
            value={props.color}
            onChange={(e) => handleChange(e.target.value)}
            onPaste={(e) => handleChange(e.clipboardData.getData('text'))}
            name="hex"
            maxLength={7}
          />
        </div>
      )}
    </div>
  )
}
